import { render, staticRenderFns } from "./RemoteImport.vue?vue&type=template&id=265b5390&"
import script from "./RemoteImport.vue?vue&type=script&lang=ts&"
export * from "./RemoteImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports